import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ENVIRONMENT, LogsService } from '@cfp/core';
import { LayoutContainer } from '@cfp/shared/ui/layout-container';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cfp-portfolio-not-loaded-page',
  templateUrl: './portfolio-not-loaded-page.html',
  imports: [LayoutContainer, TranslateModule]
})
export class PortfolioNotLoadedPage implements OnInit {
  private readonly environment = inject(ENVIRONMENT);
  private readonly logsService = inject(LogsService);
  private readonly activatedRoute = inject(ActivatedRoute);

  protected backgroundUrl = this.environment.images.loginBackground
    ? `url(${this.environment.customerAssetsDir}img/${this.environment.images.loginBackground})`
    : undefined;

  public ngOnInit(): void {
    if (this.activatedRoute.snapshot.queryParams['reason']) {
      this.logsService.postLog(this.activatedRoute.snapshot.queryParams['reason']);
    }
  }
}
